__turbopack_context__.v({
  "center": "Zjg78a_center",
  "footer": "Zjg78a_footer",
  "images": "Zjg78a_images",
  "info": "Zjg78a_info",
  "main": "Zjg78a_main",
  "subtitle": "Zjg78a_subtitle",
});
